import { Maybe } from 'types/graphqlTypes'
import { DISPLAY } from 'constants/display'
import { getFormattedTime } from './getFormattedTime'

/**
 * @example
 * ```
 * getFormattedTime('2020-01-01T00:00:00.000Z', 'America/New_York') // '12/31 7:00pm EST'
 * ```
 */
export const getAppointmentTime = (
  startAt: Maybe<string>,
  endAt: Maybe<string>,
  timezone: string
): string => {
  const startAtFormatted = getFormattedTime(startAt, timezone)
  const endAtFormatted = getFormattedTime(endAt, timezone)
  const appointmentTimeFormatted = [startAtFormatted, endAtFormatted]
    .filter(val => !!val)
    .join(' - ')
  return appointmentTimeFormatted || DISPLAY.empty
}
